import { COLUMN_AREA, COLUMN_NAME, COLUMN_SITE, COLUMN_TIME_PATTERN, COLUMN_DAYS, COLUMN_START_TIME, COLUMN_DURATION } from "../../constants/column-types";
import { FILTER_ACCESS_TIME_PATTERN, FILTER_AREA, FILTER_SITES, FILTER_DAYS } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";


const AccessGroupColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "agName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 1,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    },
    {
        heading: "Access Area",
        accessor: "area",
        isNumeric: false,
        id: 2,
        sortByName: "area.areaName",
        sortDirection: "asc",
        active: true,
        searchOnName: "area.id",
        lookupName: "area.areaName",
        translationKey: "accessArea",
        columnId: COLUMN_AREA,
        filterId: FILTER_AREA,
        settingDataName: "area"
    },
    {
        heading: "Access Time Pattern",
        accessor: "accessTimePatterns",
        isNumeric: false,
        id: 3,
        sortByName: "accessTimePattern.atpName",
        sortDirection: "asc",
        active: true,
        searchOnName: "accessTimePattern.id",
        lookupName: "accessTimePattern.atpName",
        translationKey: "accessTimePattern",
        columnId: COLUMN_TIME_PATTERN,
        settingDataName: "accessTimePattern",
        filterId: FILTER_ACCESS_TIME_PATTERN
    },
    {
        heading: "Days",
        accessor: "days",
        isNumeric: false,
        id: 4,
        active: true,
        searchOnName: "days", //This days is a placeholder so that we can get the search icon in the column heading
        lookupName: "days",
        translationKey: "days",
        columnId: COLUMN_DAYS,
        filterId: FILTER_DAYS,
    },
    {
        heading: "Start Time",
        accessor: "startTime",
        isNumeric: false,
        id: 5,
        active: true,
       // sortDirection: "asc",
       // sortByName: "accessTimePattern.atpStartTime",
        translationKey: "startTime",
        columnId: COLUMN_START_TIME,
    },
    {
        heading: "Duration",
        accessor: "duration",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "duration",
        columnId: COLUMN_DURATION,
    },
    {
        heading: "Members",
        accessor: "enrolments",
        isNumeric: true,
        id: 7,
        active: true,
        translationKey: "members"
    },
    {
        heading: "Profiles",
        accessor: "accessProfile",
        isNumeric: true,
        id: 8,
        active: true,
        translationKey: "profiles"   
    }
];

export default AccessGroupColumns;
